import { Component } from '@angular/core';
import { share } from 'rxjs';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-print-report',
  imports: [SharedModule,RouterModule],
  templateUrl: './print-report.html',
  styleUrl: './print-report.scss'
})
export class PrintReport {

}
